import { ViewColumnSystemName } from '../enums/ViewColumnSystemName';

export const viewGridPinColumns: ViewColumnSystemName[] = [ViewColumnSystemName.Ticker];
